import BaseModulePlugins from '@/store/baseModule/plugins';
import router from '@/router';
import { ACTIONPLANS_LIST_ROUTE_NAME } from '@/router/actionplans.router';
import { ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME } from '@/router/actions.router';

export default (store, modulePath) => {
  const basePlugin = new BaseModulePlugins({
    paramId: 'actionplanId',
    module: modulePath,
    store,
  });
  basePlugin.setCurrentLoading();
  basePlugin.onInit(() => {
    basePlugin.persistVuexMutationsToLocalStorage([
      'SET_ATTRIBUTES_OBJ',
      'SET_ITEMS_SORT_BY',
      'SET_VIEW_TABLE',
      'SET_ORDER_ASC',
    ]);

    basePlugin.loadCurrentOnRouteParamsChange();
    store.subscribe((mutation) => {
      if (mutation.type === 'entities/SET_CURRENT') {
        store.dispatch(`${modulePath}/setGlobalSearch`, null);
      }
    });
    basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
      serverSide: true,
      autocomplete: true,
      attribute: 'action_plan_status',
      filter: `${modulePath}/status`,
    });

    basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
      serverSide: true,
      autocomplete: true,
      attribute: 'action_plan_type',
      filter: `${modulePath}/types`,
    });

    basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({
      loadingAttributes: ['action_plan_status', 'action_plan_type'],
    });

    basePlugin.onItemsLoaded((authors) => {
      store.dispatch(`${modulePath}/setAttributesObjRef`, {
        attribute: 'author_id',
        serverSide: true,
        autocomplete: true,
        values: authors,
      });
      store.dispatch(`${modulePath}/setAttributesObjRefLoading`, false);
      const oldAuthorIdx =
        store.getters[`${modulePath}/attributesObj`].author_id.values;
      store.dispatch(`${modulePath}/setFilterAttribute`, {
        attribute: 'author_id',
        values: oldAuthorIdx.filter((id) =>
          authors.map((item) => item.id).includes(id)
        ),
      });
    }, `${modulePath}/authors`);

    basePlugin.onItemAddedOrModified(() => {
      store.dispatch(`${modulePath}/refreshItems`);
    });

    basePlugin.onItemDeleted(() => {
      store.dispatch(`${modulePath}/authors/refreshItems`);
      router.push({
        name: ACTIONPLANS_LIST_ROUTE_NAME,
      });
    });

    store.subscribe((mutation, state) => {
      if (
        mutation.type === `${modulePath}/UPDATE_SUCCESS` &&
        state.RouteModule.name === ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME
      ) {
        store.dispatch(`${modulePath}/actions/refreshItems`, mutation.payload);
      }
    });
  });
};
